module.exports = __webpack_public_path__ + "img/checkbox_s.7ce062a4.png";